import CryptoJS from "crypto-js";
import md5 from "js-md5";

//正式
let md5Json = {
  md5Key: process.env.VUE_APP_MD5_KEY,
  aesKey: process.env.VUE_APP_AES_KEY,
  iv: process.env.VUE_APP_IV,
}

export function generateEncryptedParams(params) {
    // 在入参参数中加入时间戳 timestamp
    params.timestamp = Math.floor(Date.now() / 1000);
    // console.log(params.current,"current")
    // 1. 针对 JSON 参数进行 ASCII 码的从小到大的排序。
    const sortedKeys = Object.keys(params).sort();
    const sortedParams = {};
  
    sortedKeys.forEach((key) => {
      sortedParams[key] = params[key];
    });
    
    // 2. 根据 JSON key=JSONvalue&JSONkey=JSONvalue 生成字符串。
    let paramString = "";
    for (const key in sortedParams) {
      paramString += `${key}=${sortedParams[key]}&`;
    }
  
    // 3. 生成 sign 签名前的明文字符串。
    paramString += 'key=' + `${md5Json.md5Key}`;
    console.log(paramString);
    // 4. 通过 MD5 加密该字符串生成 sign。
    const sign = md5(paramString).toUpperCase() ;
  
    // 5. 将 sign 拼接在入参的 JSON 中。
    sortedParams.sign = sign;
    
    sortedParams.timestamp = params.timestamp;
    // 6. 将整个 JSON 字符串通过 AES 加密得到入参参数。
    const encryptedParams = CryptoJS.AES.encrypt(
      JSON.stringify(sortedParams),
      CryptoJS.enc.Utf8.parse(md5Json.aesKey),
      {
        iv: CryptoJS.enc.Utf8.parse(md5Json.iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString();
    return encryptedParams;
  }

  